import React from "react";
import "./card/CardText";

export default function TextTitle(props) {

  return (
    <div 
    style={{
      color: "white",
      backgroundColor: "black",
      textAlign: "center",
      overflow: "hidden",
      padding: "50vh 0vw 20vh 0vw"
    }}>
       {props.textTitle.split("\r\n\r\n").map((p, i) => (
        <div
        key={i}
        style={{
          color: "white",
          fontWeight: "600",
          fontSize: props.isMobile? (i===0? "50px": (i===1) ? "5vw":"3vw"):(i===0? "50px": (i===1) ? "35px":"25px"),
          textAlign: "center",
          margin: props.isMobile? "1vw 5vw":"1vw 20vw",
          padding: props.isMobile? "2vw":"0vw",
        }}
      >
        {p}
        <br/>
      </div>
      ))}
    </div>
  );
}
